import React from "react";
import MuiButton from "@mui/material/Button";
import { Link } from "@/components/Link";
import { ButtonBaseProps } from "@mui/material";

type ButtonProps = ButtonBaseProps & {
  href?: string;
  children: React.ReactNode;
  component?: React.ElementType;
  variant?: "text" | "outlined" | "contained";
  color?: "inherit" | "primary" | "secondary" | "success" | "error";
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
  noWrapper?: boolean;
};

const Button = ({
  href,
  children,
  size = "small",
  fullWidth,
  noWrapper,
  ...props
}: ButtonProps) => {
  const linkProps = href ? { component: Link, to: href } : {};
  const Wrapper = noWrapper ? React.Fragment : "div";

  return (
    <Wrapper>
      <MuiButton
        component={href ? Link : undefined}
        variant={props.variant ?? "contained"}
        color={props.color ?? "primary"}
        size={size ?? "medium"}
        {...linkProps}
        {...props}
        sx={{
          borderRadius: 999,
          textTransform: "none",
          width: fullWidth ? "100%" : undefined,
          padding:
            size === "large"
              ? "1rem 2.3rem"
              : size === "medium"
              ? "0.5rem 1.5rem"
              : "0.3rem 1rem",
          fontSize: size === "large" ? "1.2rem" : "1rem",
          fontWeight: size === "large" ? 600 : 500,
          ...(props.sx ?? {}),
        }}
      >
        {children}
      </MuiButton>
    </Wrapper>
  );
};

export default Button;
